export const DEFAULT_ANNOUNCEMENT_PRIORITY = 'polite' as const;
